<template>
  <form @submit.prevent="login">
    <div class="p-field">
      <div class="p-text-center">
        <span class="p-input-icon-left">
          <i class="pi pi-user"/>
          <InputText ref="emailInput" id="email" type="email" :class="errors.email ? 'p-invalid' : ''"
                     v-model="form.email" placeholder="Email" required autofocus/>

          <div v-if="errors.email">
            <small id="email-error" class="p-error">{{ this.errors.email }}</small>
          </div>

        </span>
      </div>
    </div>

    <div class="p-field">
      <div class="p-text-center">
        <span class="p-input-icon-left p-mt-1">
          <i class="pi pi-key"/>
          <InputText id="password" type="password" v-model="form.password" placeholder="Password" required/>
        </span>
      </div>
    </div>

    <div class="p-mt-3 p-text-center">
      <Button type="submit" label="Iniciar sesión" class="submit-button"/>
    </div>
  </form>

  <Toast/>

</template>

<script>
import {UserTypes} from "src/constants";

export default {
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      errors: {
        email: null,
        password: null,
      },
      loading: true,
    }
  },
  methods: {
    async login() {
      this.loading = true;

      try {
        /** @type {Response} */
        const response = await this.$repository.auth.login(this.form);

        const adminTypes = [UserTypes.admin, UserTypes.super_admin];

        if (!adminTypes.includes(response.data.user.type)) {
          this.$toast.add({
            severity: 'error',
            summary: 'Usuario no valido',
            detail: 'Solo usuarios tipo ADMIN, pueden ingresar'
          });

          this.cleanForm();

          return;
        }

        localStorage.setItem('access_token', response.data.access_token)
        localStorage.setItem('user', JSON.stringify(response.data.user))

        this.$router.push({
          path: '/'
        });

      } catch (err) {

        this.$toast.add({
          severity: 'error',
          summary: err.response.data.message
        });

      } finally {
        this.loading = false;
      }
    },
    cleanForm() {
      this.email = null;
      this.password = null;
      this.$refs.emailInput.focus();
    }
  }
}
</script>

<style scoped lang="scss">
.p-input-icon-left input {
  font-size: 1.1rem;
  padding: 0.85rem 1.1rem;
  border-radius: 0.5rem;
  border: 1px solid #dcdcdc;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: border-color 0.3s, box-shadow 0.3s;
  background-color: #fff;
}

.p-input-icon-left input:focus {
  border-color: #4b79a1;
  box-shadow: 0 0 4px rgba(75, 121, 161, 0.4);
}

.p-input-icon-left {
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
}

.p-input-icon-left i {
  position: absolute;
  left: 1rem;
  color: #999;
}

.p-input-icon-left input {
  padding-left: 2.5rem;
  width: 100%;
}

.p-error {
  font-size: 0.85rem;
  color: #ff4438;
  margin-top: 0.25rem;
  display: block;
  animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.submit-button {
  font-size: 1rem;
  padding: 0.75rem 1.5rem;
  border-radius: 0.5rem;
  background-color: #ff4438;
  border: none;
  color: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  transition: background-color 0.3s ease;
}

.submit-button:hover {
  background-color: #e2332a;
}
</style>